import { render } from "./TestimonialModal.vue?vue&type=template&id=34e4be74&scoped=true&ts=true"
import script from "./TestimonialModal.vue?vue&type=script&lang=ts"
export * from "./TestimonialModal.vue?vue&type=script&lang=ts"

import "./TestimonialModal.vue?vue&type=style&index=0&id=34e4be74&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e4be74"]])

export default __exports__